(()=>{
  if(window.__threeScrollCopyLoaded)return;
  window.__threeScrollCopyLoaded=true;
  const reduced=matchMedia('(prefers-reduced-motion: reduce)').matches;
  const states=new Map();
  const color=value=>{
    const v=(value||'').trim();
    if(/^#[0-9a-f]{3}$/i.test(v))return v.slice(1).split('').map(x=>parseInt(x+x,16));
    if(/^#[0-9a-f]{6}$/i.test(v))return[parseInt(v.slice(1,3),16),parseInt(v.slice(3,5),16),parseInt(v.slice(5,7),16)];
    const m=v.match(/\d+/g);
    return m?[+m[0],+m[1],+m[2]]:[0,0,0];
  };
  const wrap=root=>{
    if(root.dataset.scrollReady)return;
    root.dataset.scrollReady='true';
    const targets=root.querySelectorAll('[data-scroll-copy-text]');
    let index=0;
    targets.forEach(target=>{
      const walker=document.createTreeWalker(target,NodeFilter.SHOW_TEXT);
      const nodes=[];
      while(walker.nextNode())if(walker.currentNode.nodeValue.trim())nodes.push(walker.currentNode);
      nodes.forEach(node=>{
        const frag=document.createDocumentFragment();
        node.nodeValue.split(/(\s+)/).forEach(part=>{
          if(!part)return;
          if(/^\s+$/.test(part)){
            frag.appendChild(document.createTextNode(part));
            return;
          }
          const word=document.createElement('span');
          word.className='scroll-word';
          Array.from(part).forEach(character=>{
            const letter=document.createElement('span');
            letter.className='scroll-letter';
            letter.dataset.letter=String(index++);
            letter.textContent=character;
            word.appendChild(letter);
          });
          frag.appendChild(word);
        });
        node.replaceWith(frag);
      });
    });
    const css=getComputedStyle(root);
    states.set(root,{
      current:0,
      target:0,
      letters:[...root.querySelectorAll('.scroll-letter')],
      from:color(css.getPropertyValue('--scroll-inactive')),
      to:color(css.getPropertyValue('--scroll-active')),
      strength:Number(root.dataset.scrollSpring||7)
    });
    if(reduced)states.get(root).current=states.get(root).target=1;
  };
  const setTargets=()=>{
    document.querySelectorAll('[data-scroll-copy]').forEach(root=>{
      wrap(root);
      const s=states.get(root);
      const rect=root.getBoundingClientRect();
      const start=innerHeight*(Number(root.dataset.scrollStart||60)/100);
      const end=Math.min(innerHeight*.22,72);
      s.target=Math.min(1,Math.max(0,(start-rect.top)/(start-end)));
    });
  };
  let raf=0;
  let lastFrame=performance.now();
  const render=now=>{
    const elapsed=Math.min(50,Math.max(0,now-lastFrame));
    lastFrame=now;
    let moving=false;
    states.forEach(s=>{
      if(reduced){
        s.current=1;
      }else{
        const response=1100-s.strength*45;
        const scrub=1-Math.exp(-elapsed/response);
        s.current+=(s.target-s.current)*scrub;
        if(Math.abs(s.target-s.current)>.00012){
          moving=true;
        }else{
          s.current=s.target;
        }
      }
      const spread=7;
      const total=s.letters.length;
      s.letters.forEach((letter,i)=>{
        const reveal=Math.min(1,s.current/.94);
        const raw=reveal*(total+spread)-i;
        const local=Math.max(0,Math.min(1,raw/spread));
        const mix=local*local*(3-2*local);
        const rgb=s.from.map((v,n)=>(v+(s.to[n]-v)*mix).toFixed(2));
        letter.style.color='rgb('+rgb.join(',')+')';
        letter.style.transform='translate3d(0,'+((1-mix)*.8).toFixed(3)+'px,0)';
      });
    });
    raf=moving?requestAnimationFrame(render):0;
  };
  const update=()=>{
    setTargets();
    if(!raf){
      lastFrame=performance.now();
      raf=requestAnimationFrame(render);
    }
  };
  const init=()=>{
    document.querySelectorAll('[data-scroll-copy]').forEach(wrap);
    update();
  };
  init();
  document.addEventListener('shopify:section:load',init);
  if(reduced)return;
  addEventListener('scroll',update,{passive:true});
  addEventListener('resize',update,{passive:true});
})();
